/** @jsx jsx */
import { jsx } from '@emotion/core'
import { Button, FilterBtnStyle } from '@styles/button.style'
import { FilterIco } from '@shared/Icon/MatchupIcon'
import useRootStore from '@store/useRootStore'
import { PAGE_TYPE } from '@interface/common'

interface Props {
  pageType: PAGE_TYPE
}

const MatchupFilterButton = (props: Props) => {
  const { pageType } = props
  const { globalStore, logStore } = useRootStore()

  const onShowFilter = () => {
    switch (pageType) {
      case PAGE_TYPE.MATCHUP:
        logStore.writeButtonLog({ pageId: 'b010', buttonId: '005' }).catch(console.error)
        break
    }

    globalStore.setVisibleMatchupFilterSelectPopup(true)
  }

  return (
    <Button css={FilterBtnStyle} onClick={onShowFilter} className="filter-btn">
      <FilterIco/>
    </Button>
  )
}

export default MatchupFilterButton
